import decorate from '_core/utils/decorate';

export default decorate;
